module.exports = __webpack_public_path__ + "img/proposal1.8ba52828.png";